import { Pipe, PipeTransform } from '@angular/core';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser'

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: any, args?: any): any {
    if (!args) {
      return value;
    }

    // The search api search for all words in a sentence independently.
    let search = args.replace(/\s\s+/g, ' ');
    search = search.split(' ');
    search = search.filter(Boolean);

    // Match in a case insensitive maneer.
    let re = new RegExp(search.join('|'), 'gi');
    let match = value.match(re);

    // If there's no match, just return the original value.
    if (!match) {
      return value;
    }

    let output = value.replace(re, function(matched) {
      return '<strong>' + matched + '</strong>';
    });

    return this.sanitizer.bypassSecurityTrustHtml(output)
  }

}
